import React, { useEffect, useState } from "react";
import {
  BlockCpService,
  GetContentProviderData,
  GetCreateServiceCount,
  GetServicesData,
} from "../../../../api/Api";
import CustomModal from "../../../../components/Modal/CustomModal";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import CreateService from "./createService/CreateService";
import PaginationComponent from "../../../../components/Pagination/PaginationComponent";
import CustomTable from "../../../../components/Table/CustomTable";
import Swal from "sweetalert2";
import EditService from "./editService/EditService";
import BlockService from "./blockService/BlockService";
import ViewService from "./viewService/ViewService";
import UnblockService from "./unBlockService/UnblockService";
import { useNavigate, useLocation } from "react-router-dom";
import "./CreateCpServices.css";


const CreateCpServices = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [enabledColumns, setEnabledColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeArr] = useState([10, 20, 30, 40, 50]);
  const [tableData, setTableData] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [tabVal, setTabVal] = useState(1);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [stateData, setStateData] = useState({
    tableLoader: true,
    countLoader: true,
    filterClick: true,
    nameFilterChecked: false,
    dateTimeFilterChecked: false,
    updatedByFilterChecked: false,
  });
  const [editCpModal, setEditCpModal] = useState(false);
  const [viewCpModal, setViewCpModal] = useState(false);
  const [contentPartner, setContentPartner] = useState("");
  const [loaders, setLoaders] = useState({
    cpLoader: false,
  });
  const [messageDescription, setMessageDescription] = useState("");
  const [cpList, setCpList] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [blockServiceModal, setBlockServiceModal] = useState(false);
  const [unblockServiceModal, setUnblockServiceModal] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();


  const userData = getFromLocalStorage("userData");
  const getAllData = async () => {
    setStateData((prev) => ({ ...prev, tableLoader: true }));
    let payload = {
      pageNo: currentPage,
      pageSize: pageSize,
      userId: userData?.id,
      status: tabVal,
      // If userGroups is 4, use userData.id, otherwise use selected contentPartner
      cpId: userData?.userGroups === 4 ? userData.id : Number(contentPartner),
    };
    const response = await GetServicesData(payload);
    console.log("resFetchBU", response);
    setStateData((prev) => ({ ...prev, tableLoader: false }));
    if (response?.statusDescription?.status == 200) {
      const contentWithActions = response?.cpServiceList?.content?.map(
        (item) => ({
          ...item,
          actions: response?.action,
        })
      );
      setTotalPages(response?.cpServiceList?.page?.totalPages);
      setTotalElements(response?.cpServiceList?.page?.totalElements);
      setTableData(contentWithActions);
      setEnabledColumns(response?.enabledColumns);
    } else if (response?.statusDescription?.status == 401) {
      handleUnauthorized();
    } else {
      setTableData([]);
      setMessageDescription(response?.statusDescription?.description || "Failed to fetch data");
      setTotalPages(null);
      setEnabledColumns([]);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleAction = async (action, rowData, newStatus) => {
    console.log("rowData", rowData, action);
    setRowData(rowData);
    if (action?.sequence == 3) {
      setEditCpModal(true);
    } else if (action?.sequence == 5) {
      setBlockServiceModal(true);
    } else if (action?.sequence == 7) {
      localStorage.setItem('selectedContentPartnerId', contentPartner);
      navigate("/manage-service/add-package", {
        state: rowData,
      });
    } else if (action?.sequencesequce == 5) {
      setUnblockServiceModal(true);
    } else if (action?.sequence == 9) {
      // Show confirmation dialog first
      const result = await Swal.fire({
        title: "Approve Service",
        text: "Are you sure you want to approve this service?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, approve",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      // If user confirms
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: userData?.id,
            id: rowData?.id,
            status: 1  // Status for approval
          };

          const response = await BlockCpService(payload);

          if (response?.statusDescription?.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Service approved successfully",
              icon: "success",
              confirmButtonText: "OK"
            });

            // Refresh data
            await getAllData();
            await getCount();
          } else {
            Swal.fire({
              title: "info",
              text: response?.statusDescription?.description || "Failed to approve service",
              icon: "info",
              confirmButtonText: "OK"
            });
          }
        } catch (error) {
          console.error("Error approving service:", error);
          Swal.fire({
            title: "Error",
            text: error?.response?.statusDescription?.description || "Failed to approve service",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      }
    }
    else if (action?.sequence == 6) {
      const result = await Swal.fire({
        title: "Unblock Service",
        text: "Are you sure you want to unblock this service?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, unblock",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      // If user confirms
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: userData?.id,
            id: rowData?.id,
            status: 1  // Status for approval
          };

          const response = await BlockCpService(payload);

          if (response?.statusDescription?.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Service approved successfully",
              icon: "success",
              confirmButtonText: "OK"
            });

            // Refresh data
            await getAllData();
            await getCount();
          } else {
            Swal.fire({
              title: "info",
              text: response?.statusDescription?.description || "Failed to approve service",
              icon: "info",
              confirmButtonText: "OK"
            });
          }
        } catch (error) {
          console.error("Error approving service:", error);
          Swal.fire({
            title: "Error",
            text: error?.response?.statusDescription?.description || "Failed to approve service",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      }
    }
    else if (action?.sequence == 10) {

      const result = await Swal.fire({
        title: "Reject Service",
        text: "Are you sure you want to reject this service?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, reject",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      // If user confirms
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: userData?.id,
            id: rowData?.id,
            status: 2  // Status for approval
          };

          const response = await BlockCpService(payload);

          if (response?.statusDescription?.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Service rejected successfully",
              icon: "success",
              confirmButtonText: "OK"
            });

            // Refresh data
            await getAllData();
            await getCount();
          } else {
            Swal.fire({
              title: "info",
              text: response?.statusDescription?.description || "Failed to reject service",
              icon: "info",
              confirmButtonText: "OK"
            });
          }
        } catch (error) {
          console.error("Error approving service:", error);
          Swal.fire({
            title: "Error",
            text: error?.response?.statusDescription?.description || "Failed to approve service",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      }
    }
    else if (action?.sequence == 2) {
      setViewCpModal(true);
    }
  };

  const getCpList = async () => {
    setLoaders((prev) => ({ ...prev, cpLoader: true }));
    let payload = {
      pageNo: 0,
      pageSize: 1000,
      userId: userData?.id,
      status: 1,
    };
    const response = await GetContentProviderData(payload);
    console.log("resFetchBU11", response);
    setLoaders((prev) => ({ ...prev, cpLoader: false }));
    if (response?.statusDescription?.status == 200) {
      setCpList(response?.userListPage?.content);
    } else if (response?.statusDescription?.status == 401) {
      handleUnauthorized();
    } else {
      setCpList([]);
    }
  };

  const handleUnauthorized = () => {
    // Clear any stored auth tokens/user data
    Swal.fire("info!", "Session expired, please login again", "info");
    localStorage.clear();
    // Navigate to login page
    navigate("/");
  };

  const getCount = async () => {
    setStateData((prev) => ({ ...prev, countLoader: true }));
    let payload = {
      cpId: contentPartner,
    };
    try {
      const response = await GetCreateServiceCount(payload);
      setStateData((prev) => ({ ...prev, countLoader: false }));
      console.log("responseCount", response);

      // Check for 401 status
      if (
        response?.status === 401 ||
        response?.statusDescription?.status === 401
      ) {
        handleUnauthorized();
        return;
      }

      if (response?.statusDescription?.status === 200 || response?.statusDescription?.status === 210) {
        setTabs(response?.serviceCount);
      } else {
        setTabs([]);
        // Swal.fire("info!", response?.statusDescription?.description, "info");
        setStateData((prev) => ({ ...prev, tableLoader: false }));
      }
    } catch (error) {
      // Also check for 401 in caught errors
      if (error?.response?.status === 401) {
        Swal.fire("info!", error?.response?.data?.statusDescription?.message || "Session expired, please login again", "info");
        handleUnauthorized();
        return;
      }
      setStateData((prev) => ({ ...prev, countLoader: false }));
      Swal.fire("error!", "Something went wrong!", "error");
    }
  };

  useEffect(() => {
    if (contentPartner) {
      getCount();
    }
  }, [contentPartner]);

  // useEffect(() => {

  //     getAllData();

  // }, []);
  useEffect(() => {
    if (contentPartner && tabs.length > 0) {
      getAllData();
    }
  }, [currentPage, pageSize, contentPartner, tabVal, tabs.length]);

  useEffect(() => {
    getCpList();
  }, []);

  useEffect(() => {
    if (userData?.userGroups === 4) {
      // If userGroups is 4, set contentPartner to userData.id
      setContentPartner(userData.id.toString());
    } else {
      // Otherwise, check for saved contentPartnerId
      const savedContentPartnerId = localStorage.getItem('selectedContentPartnerId');
      if (savedContentPartnerId) {
        setContentPartner(savedContentPartnerId);
      }
    }
  }, [userData]);


  const handleRefresh = () => {
    getAllData();
    getCount();
  }
  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">
                <div className="row">
                  <div className="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb breadcrumb_bg">
                        <li className="breadcrumb-item">
                          <a className="breadcrumb_1">Manage Service</a>
                        </li>
                        <li className="breadcrumb-item active breadcrumb_2 d-flex align-items-center">
                          <span>CP Services Details</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  {/* Only show Create Service button if userGroups is not 4 */}
                  {userData?.userGroups !== 4 && (
                    <div className="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                      <div className="btn-group float-right">
                        <button
                          type="button"
                          className="btn btn-primary btn-raised btn-flat  create_cp"
                          onClick={() => setCreateUserModal(true)}
                        >
                          Create Service
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="box-body px-md-4">
                {/* <div className="row">
                  {userData?.userGroups !== 4 && (
                    <div className="form-group col-sm-4 col-12">
                        <label className="font-weight-bold">
                          Select Content Provider <sup className="text-danger">*</sup>
                        </label>
                        <div className="position-relative">
                          <select
                            className={`form-control`}
                            name="contentPartner"
                            value={contentPartner}
                            onChange={(e) => {
                              const selectedCpId = e.target.value;
                              setContentPartner(selectedCpId);
                              localStorage.setItem('selectedContentPartnerId', selectedCpId);
                            }}
                            disabled={loaders.cpLoader}
                          >
                            <option value="" selected>
                              {loaders.cpLoader
                                ? "Loading Content Provider..."
                                : "--Select Content Provider --"}
                            </option>
                            {cpList &&
                              cpList?.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.username}
                                </option>
                              ))}
                          </select>
                          {loaders.cpLoader && (
                            <span className="sr-only">Loading...</span>
                          )}
                          <div className="dropdown-icon">
                            <i
                              className="fas fa-chevron-down"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                display: loaders.cpLoader ? "none" : "block",
                              }}
                            ></i>
                          </div>
                        </div>
                    </div>
                  )}
                </div> */}
                <div className="row">
                  {/* Only show Content Provider select if userGroups is not 4 */}
                  {userData?.userGroups !== 4 && (
                    <div className="form-group col-sm-4 col-12">
                      <label className="">
                        Select Content Provider <sup className="text-danger">*</sup>
                      </label>
                      <div className="position-relative" style={{ width: "100%" }}>
                        <select
                          className="form-control w-100"
                          style={{ maxWidth: "100%" }}
                          name="contentPartner"
                          value={contentPartner}
                          onChange={(e) => {
                            const selectedCpId = e.target.value;
                            setContentPartner(selectedCpId);
                            localStorage.setItem("selectedContentPartnerId", selectedCpId);
                          }}
                          disabled={loaders.cpLoader}
                        >
                          <option value="">
                            {loaders.cpLoader
                              ? "Loading Content Provider..."
                              : "--Select Content Provider --"}
                          </option>
                          {cpList &&
                            cpList.map((item) => (
                              <option key={item?.id} value={item?.id}>
                                {item?.username}
                              </option>
                            ))}
                        </select>

                        {loaders.cpLoader && <span className="sr-only">Loading...</span>}

                        <div className="dropdown-icon">
                          <i
                            className="fas fa-chevron-down"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              display: loaders.cpLoader ? "none" : "block",
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {contentPartner && !stateData?.countLoader && (
                  <>
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      {tabs &&
                        tabs.map((item) => (
                          <li
                            className="nav-item position-relative"
                            role="presentation"
                          >
                            <a
                              className={`nav-link ${item?.tabStatus == tabVal ? "active" : ""
                                } approved_cp`}
                              id="home-tab"
                              data-toggle="tab"
                              href={`#${item?.tabStatus}`}
                              role="tab"
                              aria-controls="home"
                              aria-selected="true"
                              onClick={() => setTabVal(item?.tabStatus)}
                            >
                              {item?.tabName}
                            </a>
                            <span
                              className={`badge badge-pill ${item?.colorCode} rounded-circle count`}
                            >
                              {item?.defaultCount}
                            </span>
                          </li>
                        ))}
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active pt-2"
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        {stateData?.tableLoader ? (
                          <div className="container">
                            <div className="row g-3">
                              <div className="col-12">
                                <div className="placeholder-glow">
                                  <div
                                    className="placeholder col-12 rounded"
                                    style={{ height: "40px" }}
                                  ></div>
                                </div>
                              </div>
                              {[...Array(5)].map((_, index) => (
                                <div className="col-12" key={index}>
                                  <div className="placeholder-glow">
                                    <div
                                      className="placeholder col-12 rounded"
                                      style={{ height: "50px" }}
                                    ></div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : !stateData?.tableLoader && tableData?.length > 0 ? (
                          <>
                            <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                              <div className="d-flex">
                                <span>Show</span>
                                <select
                                  className="form-select count_select mx-2"
                                  value={pageSize}
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setCurrentPage(0);
                                  }}
                                  style={{ width: "auto" }}
                                >
                                  {pageSizeArr?.map((size) => (
                                    <option key={size} value={size}>
                                      {size}
                                    </option>
                                  ))}
                                </select>
                                <span>entries</span>
                              </div>
                              <div>
                                <button type="button" className="btn btn-primary ref_but" onClick={handleRefresh}>Refresh &nbsp;
                                  <i className="fas fa-sync ms-auto" onClick={handleRefresh}></i>
                                </button>
                              </div>
                            </div>
                            <div id="table">
                              <CustomTable
                                data={tableData}
                                enabledColumns={enabledColumns}
                                onAction={handleAction}
                                currentPage={currentPage}
                                pageSize={pageSize}
                              />
                            </div>

                            <div
                              className="d-flex justify-content-between align-items-center  flex-column flex-md-row w-100"
                              id="pagination"
                            >
                              <div className="mr-3 line_pagination px-2 px-md-0">
                                Showing {currentPage * pageSize + 1} to{" "}
                                {Math.min(
                                  (currentPage + 1) * pageSize,
                                  tableData.length + currentPage * pageSize
                                )}{" "}
                                of {totalElements} entries
                              </div>
                              <div className="pages">
                                <PaginationComponent
                                  currentPage={currentPage}
                                  onPageChange={handlePageChange}
                                  totalPages={totalPages}
                                />
                              </div>
                            </div>
                          </>
                        ) : !stateData?.tableLoader &&
                          tableData?.length == 0 ? (
                          <div className="d-flex justify-content-center">
                            <h4>{messageDescription}</h4>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* create cp modal */}
      <CustomModal
        show={createUserModal}
        onHide={() => {
          setCreateUserModal(false);
        }}
        title="Create Service"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <CreateService
          setCreateUserModal={setCreateUserModal}
          getAllData={getAllData}
          getCount={getCount}
          cp={contentPartner}
        />
      </CustomModal>

      {/* edit cp modal */}
      <CustomModal
        show={editCpModal}
        onHide={() => {
          setEditCpModal(false);
        }}
        title="Edit Service Details"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
          <EditService
            setEditCpModal={setEditCpModal}
            editData={rowData}
            getAllData={getAllData}
            getCount={getCount}
            cp={contentPartner}
          />
        </div>
      </CustomModal>

      {/* block service modal */}
      <CustomModal
        show={blockServiceModal}
        onHide={() => {
          setBlockServiceModal(false);
        }}
        title="Block Service"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <BlockService
          setBlockServiceModal={setBlockServiceModal}
          editData={rowData}
          getAllData={getAllData}
          getCount={getCount}
          cp={contentPartner}
        />
      </CustomModal>

      {/* unblock service modal */}
      <CustomModal
        show={unblockServiceModal}
        onHide={() => {
          setUnblockServiceModal(false);
        }}
        title="Unblock Service"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <UnblockService
          setUnblockServiceModal={setUnblockServiceModal}
          editData={rowData}
          getAllData={getAllData}
          getCount={getCount}
          cp={contentPartner}
        />
      </CustomModal>

      {/* view cp modal */}
      <CustomModal
        show={viewCpModal}
        onHide={() => {
          setViewCpModal(false);
        }}
        title="View Service Detail"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
          <ViewService viewData={rowData} />
        </div>
      </CustomModal>
    </div>
  );
};

export default CreateCpServices;
